"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EUiContainers = void 0;
var EUiContainers = /*#__PURE__*/function (EUiContainers) {
  EUiContainers["TR"] = "tr";
  EUiContainers["TD"] = "td";
  EUiContainers["DIV"] = "div";
  EUiContainers["LI"] = "li";
  return EUiContainers;
}({});
exports.EUiContainers = EUiContainers;